"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var BaseElement = function (_super) {
  __extends(BaseElement, _super);

  function BaseElement() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      element: null,
      mounted: false,
      ready: false
    };
    /* tslint:disable:readonly-keyword */

    _this.elementNode = null;
    return _this;
  }
  /* tslint:enable:readonly-keyword */


  BaseElement.prototype.componentWillUnmount = function () {
    if (this.state.mounted && !this.state.element) {
      // tslint:disable-next-line:no-console
      console.log("WARNING Element does not exist, please fix the setupElement method and add setState({element})");
      return;
    }

    if (this.state.element) {
      this.state.element.destroy();
    }
  };

  BaseElement.prototype.componentDidMount = function () {
    this.handleSetupElement();
  };

  BaseElement.prototype.setupElement = function () {
    throw new Error("Please implement method setupElement");
  };

  BaseElement.prototype.handleSetupElement = function () {
    if (!this.props.Rebilly.ready) {
      /**
       * The remote api isn't ready
       */
      return;
    }

    if (this.state.mounted) {
      /**
       * The field already mounted
       */
      return;
    }

    if (!this.elementNode) {
      /**
       * Component dom element not mounted
       */
      return;
    }
    /**
     * Setup field
     */
    // @ts-ignore


    this.state.mounted = true;
    this.setupElement();
  };

  BaseElement.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    // we can't use the componentDidUpdate, componentWillReceiveProps methods
    // also, we can't return true here (to avoid the dom element re-render)
    // so, in that case we had to use that method as componentDidUpdate or componentWillReceiveProps
    // with some magic
    var rules = [// @ts-ignore
    [this.props.Rebilly.ready, nextProps.Rebilly.ready], // @ts-ignore
    [this.state.mounted, nextState.mounted], // @ts-ignore
    [this.state.ready, nextState.ready], // @ts-ignore
    [!!this.state.element, !!nextState.element]];
    var shouldUpdate = rules.find(function (_a) {
      var prev = _a[0],
          next = _a[1];
      return prev !== next;
    });

    if (shouldUpdate) {
      // @ts-ignore
      this.props = nextProps;
      this.handleSetupElement(); // @ts-ignore

      this.state = __assign({}, nextState);
    }

    return false;
  };

  BaseElement.prototype.render = function () {
    var _this = this;

    return React.createElement("div", {
      id: this.props.id,
      ref: function ref(node) {
        return _this.elementNode = node;
      }
    });
  };

  return BaseElement;
}(React.Component);

exports.default = BaseElement;